export default "assets/images/texture_papier_transparent-82fe2e30.png";